export default "__VITE_ASSET__CoImspWM__"